import * as Yup from "yup";
import { forceInt } from "Utils";
import { transform as lockTransformer } from "./Lock";
import { transform as issueTransformer } from "./Issue";
import { transform as userTransformer } from "./User";
import { transform as workflowTransformer } from "./Workflow";
import { transform as contentTransformer } from "./Content";

export const AssignmentValidationSchema = Yup.object().shape({});

export const AssignmentObjectSchema = {
    id: null,
    uuid: null,
    srn: null,
    content: null,
    title: null,
    type: null,
    created_at: null,
    modified_at: null,
    due_at: null,
    creator_id: null,
    issue_id: null,
    workflow_id: null,
    contact_name: null,
    contact_phone: null,
    location: null,
    action_start_time: null,
    action_end_time: null,
    status: null,
    creator: {},
    issue: {},
    workflow: {},
    users: [],
    children: [],
};

/**
 * Transform API object to a ChannelMeta object
 * @param {object} requestData JSON object from the API
 * @returns Object
 */
export function transform(requestData) {
    if (requestData.data) {
        return requestData.data.map((item) => transform(item));
    }

    let assignment = Object.assign({}, AssignmentObjectSchema, {
        id: forceInt(requestData.id),
        uuid: requestData.uuid,
        srn: requestData.srn,
        title: requestData.title,
        content: requestData.content,
        type: requestData.type,
        created_at: requestData.created_at,
        modified_at: requestData.modified_at,
        due_at: requestData.due_at ? requestData.due_at : null,
        creator_id: requestData.creator_id,
        issue_id: requestData.issue_id,
        workflow_id: requestData.workflow_id,
        contact_name: requestData.contact_name,
        contact_phone: requestData.contact_phone,
        location: requestData.location,
        action_start_time: requestData.action_start_time,
        action_end_time: requestData.action_end_time,
        status: forceInt(requestData.status),
        edit_url: `/app/planner/assignment/${requestData.uuid}`,
        object_type: "assignment",
    });

    if (requestData.lock) {
        let lock = lockTransformer(requestData.lock);
        assignment = Object.assign({}, assignment, { lock: lock });
    }

    if (requestData.creator) {
        let user = userTransformer(requestData.creator);
        assignment = Object.assign({}, assignment, { creator: user });
    }
    if (requestData.workflow) {
        let workflow = workflowTransformer(requestData.workflow);
        assignment = Object.assign({}, assignment, { workflow: workflow });
    }

    if (requestData.users) {
        assignment = Object.assign({}, assignment, {
            users: userTransformer(requestData.users),
        });
    }

    if (requestData.issue) {
        assignment = Object.assign({}, assignment, {
            issue: issueTransformer(requestData.issue),
        });
    }

    if (requestData.children) {
        assignment = Object.assign({}, assignment, {
            children: contentTransformer(requestData.children),
        });
    }

    return assignment;
}

/**
 * Serialize the content object to a string
 * @param {object} item
 * @returns string
 */
export function serialize(item) {
    return JSON.stringify(item);
}

/**
 * Deserialize json string
 * @param {string} item
 * @returns object
 */
export function deserialize(item) {
    return JSON.parse(item);
}

/**
 *
 * @param {object} item The object being saved
 * @param {object} resetVars Values to overwrite after preparation
 * @returns Object
 */
export function prepare(item, resetVars = {}) {
    return Object.assign(
        {},
        item,
        {
            object_type: undefined,
            edit_url: undefined,
        },
        resetVars
    );
}
